import {Component, Input, OnInit} from '@angular/core';
import { Message, User, UserDetail } from '@model';
import { OrganiserUsersService } from '@services';

@Component({
  selector: 'app-mailbox-list-item',
  templateUrl: './mailbox-list-item.component.html',
  styleUrls: ['./mailbox-list-item.component.scss']
})
export class MailboxListItemComponent implements OnInit{

  @Input() isUnread = false;
  @Input() unreadMessages : Message[] | undefined;
  @Input() users : UserDetail[] =[];
  constructor(private organiserUsersService: OrganiserUsersService) {
  }

  ngOnInit(): void {
  }
}
